export default __webpack_public_path__ + "static/media/activacion_cuenta.32108260.png";